module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"companyId":"Company ID","createdAt":"Date created","jwt":"JWT token","name":"Site name","seoPlugin":"SEO plugin","siteUrl":"Site URL","tag":"Affiliate tag","updatedAt":"Date updated"}}')
  delete Component.options._Ctor
}
